<template>
  <div class="arcgis-login">
    <div v-if="isLoggedIn" class="profile-container">
      <div class="profile-thumbnail" @click="toggleProfileMenu">
        <img :src="userThumbnailUrl" alt="Profile Image" class="thumbnail-img" />
<!--        <img v-else src="https://gis.msu.edu/portal/home/js/arcgisonline/css/images/no-user-thumb.jpg" alt="Profile Image" class="thumbnail-img" />-->
<!--        <v-icon v-else  class="thumbnail-img" >mdi-account</v-icon> &lt;!&ndash; Default icon when no thumbnail &ndash;&gt;-->
      </div>
      <div class="user-info" @click="toggleProfileMenu">
        <p class="user-fullname">{{ user.fullName }}</p>
        <p class="user-username">{{ user.username }}</p>
      </div>
      <div v-if="showProfileMenu" class="profile-menu">
        <ul>
          <li @click="viewProfile">View Profile</li>
          <li @click="logout">Logout</li>
        </ul>
      </div>
    </div>
    <div v-else>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <button v-on="on" @click="login">
            Login
          </button>
        </template>
        <span>Login to access secure features like additional map layers, dashboards, and other resources tailored to you.</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import OAuthInfo from "@arcgis/core/identity/OAuthInfo";
import IdentityManager from "@arcgis/core/identity/IdentityManager";
import Portal from "@arcgis/core/portal/Portal";

export default {
  name: 'UserProfile',
  data() {
    return {
      portalUrl: "https://gis.msu.edu/portal",
      appId: "XlsTWaHKeBeqDxMT",
      user: null,
      showProfileMenu: false,
    };
  },
  computed: {
    isLoggedIn() {
      return !!this.user;
    },

    userThumbnailUrl() {
      return this.user.thumbnailUrl || 'https://gis.msu.edu/portal/home/js/arcgisonline/css/images/no-user-thumb.jpg'
    }
  },
  mounted() {
    this.initializeOAuth();
    this.checkForUser();
  },
  methods: {
    // Initialize OAuth settings
    initializeOAuth() {
      const info = new OAuthInfo({
        appId: this.appId,
        portalUrl: this.portalUrl,
        popup: false,
      });
      IdentityManager.registerOAuthInfos([info]);
    },

    // Check if the user is already logged in
    async checkForUser() {
      try {
        const credential = await IdentityManager.checkSignInStatus(
            `${this.portalUrl}/sharing`
        );
        this.handleUser(credential.userId);
      } catch (err) {
        console.log("User not signed in");
      }
    },

    // Handle user login
    login() {
      IdentityManager.getCredential(`${this.portalUrl}/sharing`)
          .then((credential) => {
            this.handleUser(credential.userId);
          })
          .catch((err) => {
            console.error("Error during login:", err);
          });
    },

    // Set user details after login using Portal and PortalUser
    async handleUser(userId) {
      const portal = new Portal({
        url: this.portalUrl,
      });

      try {
        await portal.load(); // Load the portal

        // Access the PortalUser object via the portal instance
        const portalUser = portal.user;
        console.info('Portal User', portalUser);

        // Check if user is defined (it should be after login)
        if (portalUser) {
          this.user = portalUser;

        } else {
          console.error("No user information found.");
        }
      } catch (error) {
        console.error("Error fetching user info with PortalUser:", error);
      }
    },

    // Toggle profile menu
    toggleProfileMenu() {
      this.showProfileMenu = !this.showProfileMenu;
    },

    // View profile function (redirect to profile page)
    viewProfile() {
      window.open(`${this.portalUrl}/home/user.html?user=${this.user.username}`, '_blank');
    },

    // Logout the user and reload the application
    logout() {
      IdentityManager.destroyCredentials();
      this.user = null;
      this.userThumbnail = "";
      this.showProfileMenu = false;
      this.$router.push('/'); // Navigate to home page
      window.location.reload(); // Reload the application
    },
  },
};
</script>

<style scoped>
.arcgis-login {
  display: flex;
  align-items: center;
}

.profile-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  padding: 6px;
}

.profile-container:hover {
  background-color: #008208; /* Updated hover color */
}

.profile-thumbnail {
  width: 40px; /* Maintain size for default icon */
  height: 40px; /* Maintain size for default icon */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.thumbnail-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.user-info {
  display: flex;
  flex-direction: column;
}

.user-fullname {
  font-weight: bold;
  color: #dad8d8;
  min-width: 125px;
  margin-bottom: 0px;
}

.user-username {
  font-size: 0.85em;
  color: #dcdbdb;
  margin-bottom: 0px;
}

.profile-menu {
  position: absolute;
  top: 50px;
  right: 0;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  z-index: 100;
}

.profile-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.profile-menu li {
  padding: 10px 20px;
  cursor: pointer;
  color: #444444;
}

.profile-menu li:hover {
  background-color: #f0f0f0;
}

button {
  background-color: #0B9A6D;
  border: none;
  padding: 10px;
  cursor: pointer;
}

button:hover {
  background-color: #008208; /* Updated hover color */
}
</style>
